module.exports = __WEBPACK_EXTERNAL_MODULE_32__;


//////////////////
// WEBPACK FOOTER
// external {"root":"$","commonjs":"jquery","commonjs2":"jquery","amd":"jquery"}
// module id = 32
// module chunks = 0